import styled from "styled-components/macro";
import { NumericFormat } from "react-number-format"; // Import NumericFormat

export const InputContainer = styled.div(() => ({
}));

export const Title = styled.label(({ theme, hasError, margin }) => ({
    fontSize: "16px",
    display: "flex",
    color: hasError ? theme.color.feedback.error : theme.color.neutral["02"],
    marginBottom: "8px",
    fontFamily: "Rawline",
    alignItems: "center",
    fontWeight: "500",
    lineHeight: "150%",
    letterSpacing: 0,
    marginTop: margin ? "40px" : 0,
    [theme.breakpoint.md()]: {
        fontSize: "18px",
    },
}));

export const ErrorMessage = styled.h6(({ theme }) => ({
    textAlign: "inherit",
    display: "flex",
    alignItems: "center",
    svg: {
        margin: "0 5px 0 0",
        width: "1rem",
    },
    color: theme.color.feedback.error,
    marginTop: 0,
    marginBottom: 0,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "150%",
}));


export const RequiredIcon = styled.div(({ theme }) => ({
    color: theme.color.feedback.error,
}))

export const CurrencyStyledTextField = styled(NumericFormat)(({ theme, hasError, disabled, CalendarPicker }) => ({
        maxWidth: "100%",
        background: disabled ? theme.color.neutral["06"] : theme.color.neutral["08"],
        "-webkit-appearance": "none",
        margin: 0,
        transition: "0.3s",
        boxSizing: "border-box",
        border: `1px solid ${hasError ? theme.color.feedback.error : theme.color.neutral["04"]
            }`,
        borderRadius: "4px",
        height: "56px",
        outline: "none",
        width: "100%",
        color: hasError ? theme.color.feedback.error : theme.color.neutral["03"],
        paddingLeft: "12px",
        paddingRight: "12px",
        fontSize: "16px",
        fontFamily: "Rawline",
        fontWeight: "500",
        lineHeight: "150%",
        [theme.breakpoint.md()]: {
            fontSize: "18px",
        },
        "::placeholder": {
            color: theme.color.neutral["03"]
        },
        "::-webkit-calendar-picker-indicator": {
            color: "transparent",
            zIndex: 1,
            background: `url(${CalendarPicker}) no-repeat`,
            width: "24px",
            height: "24px",
            transform: "translateX(-2%)",
        },
    })
);
